module.exports = __webpack_public_path__ + "img/knowledge-base.fe5fea82.svg";